import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import he from './locales/he.json';
import en from './locales/en.json';

const stored =
  typeof localStorage !== 'undefined' ? localStorage.getItem('admin-refine.locale') : null;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { he: { translation: he }, en: { translation: en } },
    fallbackLng: 'en',
    lng: stored ?? 'he',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'admin-refine.locale',
      caches: ['localStorage'],
    },
  });

export default i18n;
